import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

interface FormData {
  location: string;
  email: string;
  password: string;
  confirmPassword: string;
}

interface Errors {
  location?: string;
  email?: string;
  password?: string;
  confirmPassword?: string;
}

const CreateNewSignIn = async(place:string,password:string,mail:string) => {
  try {
    const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/AddNewSignIn.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      place,
      password,
      mail,
    }),
  });

  if (response.ok) {
    const data = await response.json();
    // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
    //console.log('Erfolgreich eingeloggt:', data);
    //console.log('tag:', data['tag']);
    const answer = data['message'];
    if(answer == 'OK' ){
      //Eintrag erledigt
      return true
    }
    else {
      //Eintrag nicht erledigt
      return false
    }
  } else {
    const data = await response.json();
    //console.log(data);
    console.error('Fehler beim Einloggen:', response.statusText);
    return false
  }
} catch (error) {
  console.error('Fehler beim Einloggen:', error);
  return false
}
}

const CheckExistSQLEntrie = async(columnName:string,columnValue:string) => {
  try {
    const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/SignInChecker.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      columnName,
      columnValue
    }),
  });

  if (response.ok) {
    const data = await response.json();
    // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
    //console.log('Erfolgreich eingeloggt:', data);
    //console.log('tag:', data['tag']);
    const answer = data['message'];
    if(answer != 'OK' ){
      //Eintrag existiert
      return true
    }
    else {
      //Eintrag existiert nicht
      return false
    }
  } else {
    const data = await response.json();
    //console.log(data);
    console.error('Fehler beim Einloggen:', response.statusText);
    return true
  }
} catch (error) {
  console.error('Fehler beim Einloggen:', error);
  return true
}
}

function SignIn() {
  const [formData, setFormData] = useState<FormData>({
    location: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState<Errors>({});
  const [submitted, setSubmitted] = useState(false);
  const [showAGB, setShowAGB] = useState(false);
  const [showDSGVO, setShowDSGVO] = useState(false);
  const [showUse, setShowUse] = useState(false);
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordVisibleConfirmed, setPasswordVisibleConfirmed] = useState(false);

  const handleCheckboxChangeAGB = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowAGB(e.target.checked);
  };

  const handleCheckboxChangeDSGVO = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowDSGVO(e.target.checked);
  };

  const handleCheckboxChangeUse = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowUse(e.target.checked);
  };

  const validateForm = async (): Promise<boolean> => {
    const newErrors: Errors = {};

    // Überprüfen, ob alle Felder ausgefüllt sind und füge Fehler bei Bedarf hinzu
    if (!formData.location.trim()) {
      newErrors.location = 'Bitte Ort eingeben';
    }else {
      // Überprüfen, ob Sonderzeichen im Ort vorhanden sind
      const regex = /^[a-zA-Z0-9\s]*$/;
      if (!regex.test(formData.location)) {
        newErrors.location = 'Sonderzeichen sind im Ort nicht erlaubt';
      } else {
        // Überprüfen, ob der Ort bereits verwendet wurde
        const stringWithoutSpaces = formData.location.replace(/\s+/g, '');
        const exists = await CheckExistSQLEntrie('login', stringWithoutSpaces);
        if (exists) {
          newErrors.location = 'Ort wird bereits verwendet';
        }
      }
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Bitte E-Mail eingeben';
    } else {
      // Überprüfen, ob es sich um eine gültige E-Mail handelt
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.email)) {
        newErrors.email = 'Bitte eine gültige E-Mail Adresse eingeben';
      }else {
        // Überprüfen, ob die E-Mail-Adresse bereits verwendet wurde
        const existsMail = await CheckExistSQLEntrie('mail', formData.email);
        if (existsMail) {
          newErrors.email = 'E-Mail Adresse wird bereits verwendet';
        }
      }
    }
    
    if (!formData.password.trim()) {
      newErrors.password = 'Bitte Passwort eingeben';
    } else if (formData.password.length < 8) {
      // Überprüfen, ob das Passwort mindestens 8 Zeichen hat
      newErrors.password = 'Passwort muss mindestens 8 Zeichen haben';
    }

    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = 'Bitte Passwort bestätigen';
    } else if (formData.password !== formData.confirmPassword) {
      // Überprüfen, ob beide Passwörter übereinstimmen
      newErrors.confirmPassword = 'Passwörter stimmen nicht überein';
    }

    setErrors(newErrors);
    // Wenn keine Fehler gefunden wurden, ist das Formular valide
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    const isValid = await validateForm(); // Warten auf die asynchrone Validierung
    if (isValid) {
      setSubmitted(true);
      //console.log('Registration successful:', formData);
      CreateNewSignIn(formData.location,formData.password,formData.email)
      navigate("/TestTime") 
    } else {
      setSubmitted(false);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const togglePasswordVisibilityConfirmed = () => {
    setPasswordVisibleConfirmed(!passwordVisibleConfirmed);
  };

  return (
    <div className='mainContainer'>
        <div className="titleContainer">
            <h2>Junior Alarm Registrierung</h2>
        </div>

        <div className='inputContainer'>
          <label>Ort:</label>
          <input 
            type="text" 
            name="location" 
            className="inputBox"
            value={formData.location} 
            onChange={handleChange} 
          />
          {errors.location && <p style={{color: 'red'}}>{errors.location}</p>}
        </div>

        <div className='inputContainer'>
          <label>Email:</label>
          <input 
            type="email" 
            name="email" 
            className="inputBox"
            value={formData.email} 
            onChange={handleChange} 
          />
          {errors.email && <p style={{color: 'red'}}>{errors.email}</p>}
        </div>

        <div className={"inputContainer"}>
          <label>Passwort:</label>
          <div className="passwordContainer">
            <input
              className='inputBox'
              placeholder='Passwort eingeben'
              name='password'
              type={passwordVisible ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
            />
            <FontAwesomeIcon
              icon={passwordVisible ? faEyeSlash : faEye}
              onClick={togglePasswordVisibility}
              className="passwordIcon"
            />
          </div>
          {errors.password && <p style={{color: 'red'}}>{errors.password}</p>}
        </div>

        <div className='inputContainer'>
          <label>Passwort bestätigen:</label>
          <div className="passwordContainer">
            <input
              className='inputBox'
              placeholder='Passwort bestätigen'
              name='confirmPassword'
              type={passwordVisibleConfirmed ? "text" : "password"}
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            <FontAwesomeIcon
              icon={passwordVisibleConfirmed ? faEyeSlash : faEye}
              onClick={togglePasswordVisibilityConfirmed}
              className="passwordIcon"
            />
          </div>
          {errors.confirmPassword && <p style={{color: 'red'}}>{errors.confirmPassword}</p>}
        </div>

        <div className="checkbox-container-Sign">
          <div className="checkbox-item-Sign">
            <input
              type="checkbox"
              id="accept-agbs"
              checked={showAGB}
              onChange={handleCheckboxChangeAGB}
            />
            <label htmlFor="accept-dsgvo" className="checkbox-label-Sign">
              Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">AGBs</a>
            </label>
          </div>

          <div className="checkbox-item-Sign">
            <input
              type="checkbox"
              id="accept-dsgvo"
              checked={showDSGVO}
              onChange={handleCheckboxChangeDSGVO}
            />
            <label htmlFor="accept-agbs" className="checkbox-label-Sign">
              Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/apps/junioralarm/agb" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>
            </label>
          </div>

          <div className="checkbox-item-Sign">
            <input
              type="checkbox"
              id="accept-agbs"
              checked={showUse}
              onChange={handleCheckboxChangeUse}
            />
            <label htmlFor="accept-agbs" className="checkbox-label-Sign">
              Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/nutzungsbedingungen" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen</a>
            </label>
          </div>
          
          
          
        </div> 

        <br></br>
        {showAGB && showDSGVO && showUse ? (
          <div className="inputContainer">
            <input
                className="inputButton"
                type="button"
                onClick={handleSubmit}
                value={"Registrieren"} />
            </div>
        ) : null}
    </div>
  );
}

export default SignIn;